import React from "react";
import { SchoolType } from "lib/types";
import { cn } from "lib/utils";

const SchoolIcon = ({ schoolType }: { schoolType: number }) => {
  return (
    <div
      className={cn(
        "text-white",
        schoolType === SchoolType.HIGH
          ? "bg-indigo-500"
          : schoolType === SchoolType.MIDDLE
          ? "bg-cyan-800"
          : schoolType === SchoolType.ELEMENTARY
          ? "bg-violet-500"
          : schoolType === SchoolType.UNIVERSITY
          ? "bg-pink-500"
          : schoolType === SchoolType.ORGANIZATION
          ? "bg-orange-500 "
          : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50",
        "rounded-md font-semibold text-xs flex items-center justify-center gap-1 h-6 w-6"
      )}
    >
      {schoolType === SchoolType.HIGH && <span>고</span>}
      {schoolType === SchoolType.MIDDLE && <span>중</span>}
      {schoolType === SchoolType.ELEMENTARY && <span>초</span>}
      {schoolType === SchoolType.UNIVERSITY && <span>대</span>}
      {schoolType === SchoolType.ORGANIZATION && <span>센</span>}
      {schoolType === SchoolType.NONE && <span> </span>}
    </div>
  );
};

export default SchoolIcon;
